import ApiService from "../../common/services/ApiService";

const api = new ApiService();

export const getExternalCurrencyRequests = async () => {
   try {
      const externalCurrencyRequest = await api.query(`/api/v2/point_requests?q[status_eq]=pending&per_page=25&q[s]=submitted_at+asc&approvable=1`);
      return externalCurrencyRequest.data;
    } catch (error) {
    }
}
